import type { HoldPayload, HoldReasonKey } from '../../../project_starburst';

/**
 * Path A single-select reasons → the existing backend `hold_reason` enum values (audited on
 * CDMX-18412). The strings equal `commonEnums.HoldReasonType.*` from
 * `@codametrix/ui-common`, but are inlined here on purpose: this stays a PURE, ui-common-free module
 * so it remains loadable + unit-testable in the local jest env (where `@codametrix/ui-common` does
 * not resolve). The ui-common-dependent wiring lives in `codingScreenApi.ts`.
 */
const REASON_TO_ENUM: Record<HoldReasonKey, string> = {
  awaitingDocumentation: 'HOLD_FOR_DOCUMENTATION_QUERY',
  needSupervisorInput: 'HOLD_FOR_MANAGER_REVIEW',
  other: 'HOLD'
};

/**
 * Map our `HoldPayload` onto the ui-common `holdCase` thunk arg (`CMxAPI.HoldCaseType`). Pure.
 * - `holdReason`: the single reason → its backend enum value.
 * - `comment`: the optional free-text note (trimmed; empty string when absent) → the backend `comment`.
 * - `coding_manager_id` is OMITTED — `HoldCaseType` types it `?: string` and the thunk applies
 *   `?? null`; it's a MANAGER reference the backend derives, NOT the acting coder.
 */
export function holdCaseArgsFromPayload(
  payload: HoldPayload,
  processInstance: AmplifyAPI.ProcessInstance
): CMxAPI.HoldCaseType {
  return {
    holdReason: REASON_TO_ENUM[payload.reason],
    comment: payload.note?.trim() ?? '',
    processInstance
  };
}
